import pom from "@/utils/pom";
import { applyDataTestId } from "@/utils/testUtils";

export interface AddToCartIcon {
  height?: number;
  width?: number;
}

export const AddToCartIcon = ({ height = 20, width = 20 }: AddToCartIcon) => {
  return (
    <div data-testid={applyDataTestId(pom.icons.addToCartIcon)}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={height}
        height={width}
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M7.00003 18.05V18M13 18.05V18M5.00004 15.9374H13.2675C13.5628 15.9375 13.8485 15.833 14.0742 15.6424C14.2998 15.4519 14.4506 15.1878 14.5 14.8966L16.6975 1.97994C16.7471 1.68898 16.898 1.42495 17.1236 1.23461C17.3492 1.04426 17.6349 0.939875 17.93 0.939941H18.75M14.9608 12.1876H4.90164C4.34421 12.1875 3.80279 12.0012 3.36341 11.6581C2.92404 11.3151 2.61191 10.835 2.47664 10.2942L1.26831 5.46091M9.00006 3V6M9.00006 6V9M9.00006 6H6.00006M9.00006 6H12.0001"
          stroke="#228800"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};
